<template>
  <Navbar />
  <div id="home_bi">
    <welcomeScreen />
    <aboutEvent />
    <performers />
    <afterMovies />
    <photoGallery />
  </div>
  <Footer />
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'

  import Navbar from '@/components/navbar.vue'
  import Footer from '@/components/footer.vue'
  import WelcomeScreen from '@/components/homepage_bi/welcomeScreen.vue'
  import AboutEvent from '@/components/homepage_bi/aboutEvent.vue'
  import performers from '@/components/homepage_bi/performers.vue'
  import photoGallery from '@/components/homepage_bi/photoGallery.vue'
  import afterMovies from '@/components/homepage_bi/afterMovies.vue'
  
  const route = ref(useRoute())
  /* onMounted(() => {}) */
</script>

<style>
.navbar.zero-bg {
    background-color: #ffffff00;
}
</style>